import React, { useState } from 'react';
import { GridFilterItem } from '@mui/x-data-grid';

export type Filter = GridFilterItem & {
  toggleReloadData: boolean;
};

export const useFilters = () => {
  const [filter, setFilter] = useState<Filter>({
    columnField: '',
    value: '',
    toggleReloadData: false
  });

  const changeFilters = (prop: 'columnField' | 'value', value: string, reloadData: boolean) => {
    const shouldReloadData = filter.columnField && reloadData;

    if (prop === 'columnField') {
      setFilter(prevState => ({
        columnField: value,
        value: '',
        toggleReloadData: shouldReloadData ? !prevState.toggleReloadData : prevState.toggleReloadData
      }));

      return;
    }

    setFilter(prevState => ({
      ...prevState,
      value,
      toggleReloadData: shouldReloadData ? !prevState.toggleReloadData : prevState.toggleReloadData
    }));
  };

  const handleClearFilters = () =>
    setFilter(prevState => ({
      columnField: '',
      value: '',
      toggleReloadData: !prevState.toggleReloadData
    }));

  const handleFilterValueChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    changeFilters('value', e.target.value, false);

  const applyFilterOnButtonClick = () => changeFilters('value', filter.value, true);

  const applyFilterOnEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') {
      return;
    }

    changeFilters('value', (e.target as HTMLInputElement).value, true);
  };

  const handleSelectFilterColumn = (e: React.ChangeEvent<HTMLInputElement>) =>
    changeFilters('columnField', e.target.value, true);

  return {
    filter,
    applyFilterOnEnter,
    applyFilterOnButtonClick,
    handleFilterValueChange,
    handleClearFilters,
    handleSelectFilterColumn
  };
};
